<template>
  <div class="modal" :class="{ 'is-active': visible }">
    <div class="modal-background" @click="$emit('close')"></div>

    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">
          {{ concept?.id ? 'Edit Concept' : 'New Concept' }}
        </p>

        <button class="delete" @click="$emit('close')"></button>
      </header>

      <section class="modal-card-body">
        <div class="field">
          <label class="label">Name</label>
          <div class="control">
            <input v-model="form.name" class="input" type="text" required />
          </div>
        </div>

        <div class="field">
          <label class="label">Scope</label>
          <div class="control">
            <div class="select is-fullwidth">
              <select v-model="form.scope">
                <option value="document">Document</option>
                <option value="item">Item</option>
                <option value="third_party">Third Party</option>
              </select>
            </div>
          </div>
        </div>
      </section>

      <footer class="modal-card-foot">
        <button class="button is-success" @click="save">Save</button>

        <button class="button" @click="$emit('close')">Cancel</button>
      </footer>
    </div>
  </div>
</template>

<script>
import api from '@/utils/axios';

export default {
  name: 'ConceptFormModal',
  props: {
    visible: { type: Boolean, default: false },
    concept: { type: Object, default: null },
  },
  data() {
    return {
      form: {
        name: '',
        slug: '',
        scope: 'document',
      },
    };
  },
  watch: {
    concept: {
      immediate: true,
      handler(val) {
        if (val) {
          this.form = {
            name: val.name,
            scope: val.scope,
          };
        } else {
          this.form = { name: '', slug: '', scope: 'document' };
        }
      },
    },
  },
  methods: {
    async save() {
      try {
        if (this.concept?.id) {
          await api.put(`/analytics/concepts/${this.concept.id}/`, this.form);
        } else {
          await api.post('/analytics/concepts/', this.form);
        }
        this.$emit('saved');
        this.$emit('close');
      } catch (e) {
        alert('Error saving concept');
      }
    },
  },
};
</script>
